import React from "react";
import CommunityList from "../../components/Community/CommunityList";

export default function PrayerList() {
  return (
    <CommunityList
      type="PRAYER"
      title="Prayer Requests"
      subtitle="Confirmed prayer requests are shown publicly."
      createButtonText="Post Prayer Requests"
      emptyStateEmoji="🙏"
      emptyStateMessage="No new confirmed requests, Keep sharing your prayers!"
      emptyStateButtonText="Be the first to share"
    />
  );
}